export const base_url = "http://localhost:3004/api/"